import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TableComponent } from './table.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { TableLoaderModule } from '../../components/table-loader/table-loader.module';




@NgModule({
  declarations: [
    TableComponent
  ],
  imports: [
    CommonModule,
    TableLoaderModule,
    NgxSkeletonLoaderModule.forRoot({
      theme: {
        // Enabliong theme combination
        extendsFromRoot: true,
        // ... list of CSS theme attributes
        height: '40px',
        width: '100%',
        margin: '10px 0px'
      },
    }),
  ],
  exports: [
    TableComponent
  ]
})
export class TableModule { }
